import Rest from '@/services/Rest'

export default class GeneratedDocumentIdService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/generatedDocumentIds'


  /**
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  statistics() {
    return this.get(`/statistics`)
  }

  /**
   * @returns {*|PromiseLike<T | never>|Promise<T | never>}
   */
  count() {
    return this.get(`/count`).then(response => response.total)
  }

}
